function u(e = sessionStorage) {
  const r = function(t) {
    if (!t)
      return {};
    const n = e.getItem(t);
    return JSON.parse(n ?? "{}");
  };
  return {
    getItem: r,
    setItem: function(t, n) {
      if (!t)
        return;
      const o = {
        ...r(t),
        ...n
      };
      e.setItem(t, JSON.stringify(o));
    },
    removeItem: function(t) {
      t && e.removeItem(t);
    },
    clear: function() {
      e.clear();
    }
  };
}
export {
  u as storage
};
